module.exports = __webpack_public_path__ + "static/img/erweima1.44775df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/erweima1.jpg
// module id = oDvF
// module chunks = 2